import { ArrowLeft, ExternalLink, Loader2, MessageSquarePlus } from 'lucide-react'
import { checklistItemUrl } from '@/shared/config/endpoints'
import { useScanActions } from '@/screens/scan/ScanActionsContext'
import { verdictColor } from '@/screens/scan/lib/sessionDisplay'
import type { ChecklistItem, ScanResult } from '@/screens/scan/types'
import { ChecklistItemCard } from './ChecklistItemCard'

/** Full-screen detail for one checklist-item scan result — mirrors ramp-web-app ScannerItemDetail. */
export function ResultDetailView({
  result,
  name,
  checklistItem,
  onBack
}: {
  result: ScanResult
  name: string
  checklistItem?: ChecklistItem
  onBack: () => void
}) {
  const { sendToChat } = useScanActions()
  const color = verdictColor(result.scanStatus)
  const loadingHighlights = !result.highlightsLoaded && !!result._id

  return (
    <>
      <div className='ramp-scan-head ramp-scan-head--back-only'>
        <button type='button' className='ramp-link ramp-scan-back' onClick={onBack}>
          <ArrowLeft size={14} /> Scan run
        </button>
      </div>

      <div className='ramp-scan-list'>
        <div className='ramp-scan-result-intro'>
          <div className='ramp-scan-title'>
            {color ? <span className='ramp-scan-dot' style={{ background: color }} /> : null}
            <a
              className='ramp-scan-result-link'
              href={checklistItemUrl(result.checklistItemId)}
              target='_blank'
              rel='noopener noreferrer'
            >
              <span className='ramp-scan-result-link-text'>{name}</span>
              <ExternalLink size={12} aria-hidden />
            </a>
          </div>
        </div>

        {loadingHighlights ? (
          <div className='ramp-scan-empty'>
            <Loader2 size={16} className='ramp-spin' /> Loading findings…
          </div>
        ) : (
          <>
            <div className='ramp-scan-card'>
              <div className='ramp-scan-card-title'>Explanation</div>
              <div className='ramp-scan-card-body'>
                {result.explanation ? (
                  <p className='ramp-scan-card-text'>{result.explanation}</p>
                ) : (
                  <p className='ramp-scan-card-empty'>No explanation available.</p>
                )}
              </div>
            </div>

            <ChecklistItemCard item={checklistItem} />
          </>
        )}
      </div>

      <div className='ramp-scan-foot'>
        <button type='button' className='ramp-scan-primary' onClick={() => sendToChat(result, name)}>
          <MessageSquarePlus size={16} /> Add to chat
        </button>
      </div>
    </>
  )
}
